import React from "react";

const ErrorsWarnings = ({ errors, warnings }) => {
  return (
    <>
      <p className="mt-2 ft-16">
        <span className="error-text ft-14 mr-2">{errors}</span> Errors Found
      </p>
      <p className="mt-2 ft-16">
        <span className="pending-text ft-14 mr-2">{warnings}</span> Warnings
        Found
      </p>
    </>
  );
};

export default ErrorsWarnings;
